import serverVars from 'server-vars';
import { getAbUuid } from 'dibs-cookie-jar/exports/abTestHelpers.ts';
import { LOCALE_US } from 'dibs-intl/exports/locales';

import { sendAnalyticsData } from './perfAnalyticsHelpers.ts';

export const trackAbTestBucket = ({
    testName,
    variant,
    ramp,
    abTestType,
}: {
    testName: string | undefined;
    variant: string | undefined;
    ramp?: number;
    abTestType?: string;
}): void => {
    if (!serverVars.get('NODE_CLIENT_ANALYTICS_TRACK_AB_TESTS')) {
        return;
    }
    if (!testName || !variant) {
        return;
    }

    const requestLocale = serverVars.get('locale') === LOCALE_US ? LOCALE_US : `non-${LOCALE_US}`;

    sendAnalyticsData(`${location.protocol}//${location.host}/soa/client-analytics/ab-test/`, {
        testName,
        variant,
        abTestType: abTestType || 'unknown',
        ramp,
        monitoringGroupName: serverVars.get('monitoringGroupName') || 'unknown',
        appVersion: serverVars.get('appVersion') || '0.0.0',
        deviceType: serverVars.get('settings.deviceType') || 'unknown',
        host: location.hostname,
        requestLocale,
        abUuid: getAbUuid(document.cookie) || undefined,
        clientUrl: location.href,
    });
};
